module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/mv_img05-9436c6b7f936f5bfab278b4217815fba.png";